import { Box, CircularProgress, InputAdornment, LinearProgress, TextField, keyframes } from '@mui/material';
import { ReactNode } from 'react';
import { getFieldControlSx } from 'components/DynamicInputField/fieldStyles';
import NumberStepper from 'components/NumberStepper';

const arrive = keyframes`
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: none; }
`;

const PendingQuoteLine = ({ label, children }: { label: string; children?: ReactNode }) => {
  if (children) {
    return (
      <Box
        sx={{ position: 'relative', animation: `${arrive} 160ms ease-out` }}
        aria-busy
        aria-label={`Adding ${label}`}
      >
        {children}
        <LinearProgress
          aria-label="Adding product"
          sx={{ position: 'absolute', left: 0, right: 0, bottom: 4, height: 2, backgroundColor: 'transparent' }}
        />
      </Box>
    );
  }
  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, animation: `${arrive} 160ms ease-out` }}
      aria-busy
      aria-label={`Adding ${label}`}
    >
      <Box sx={{ flex: 1, mb: 1 }}>
        <TextField
          variant="outlined"
          margin="dense"
          fullWidth
          disabled
          label="Product"
          value={label}
          sx={getFieldControlSx(false)}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <CircularProgress size={16} color="inherit" aria-label="Adding product" />
                </InputAdornment>
              ),
            },
          }}
        />
      </Box>
      <Box sx={{ flex: 'none', mb: 1, display: 'flex', alignItems: 'center' }}>
        <NumberStepper amount={1} min={1} disabled onChange={() => {}} />
      </Box>
    </Box>
  );
};

export default PendingQuoteLine;
